
require('./pages');
//require('./staff');
//require('./case-study');
require('./post');
//require('./retailer');